var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421,244.58V165C421,74.019,346.981,0,256,0S91,74.019,91,165v79.58c-17.459,6.192-30,22.865-30,42.42v180    c0,24.813,20.187,45,45,45h300c24.813,0,45-20.187,45-45V287C451,267.445,438.459,250.772,421,244.58z M121,165    c0-74.439,60.561-135,135-135s135,60.561,135,135v77h-30v-77c0-57.897-47.103-105-105-105c-57.897,0-105,47.103-105,105v77h-30    V165z M331,165v77H181v-77c0-41.355,33.645-75,75-75S331,123.645,331,165z M421,467c0,8.271-6.729,15-15,15H106    c-8.271,0-15-6.729-15-15V287c0-8.271,6.729-15,15-15h300c8.271,0,15,6.729,15,15V467z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,302c-24.813,0-45,20.187-45,45c0,19.555,12.541,36.228,30,42.42V437c0,8.284,6.716,15,15,15s15-6.716,15-15v-47.58    c17.459-6.192,30-22.865,30-42.42C301,322.187,280.813,302,256,302z M256,362c-8.271,0-15-6.729-15-15s6.729-15,15-15    s15,6.729,15,15S264.271,362,256,362z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.7177b97ac6e156ea5093c5b7a85db244.svg";
export { ForwardRef as ReactComponent };